export default [
  {
    url: null,
    name: 'Management',
    tag: '2',
    tagColor: 'warning',
    icon: 'BriefcaseIcon',
    submenu: [
      {
        url: '/management/users',
        name: 'Users',
        icon: 'UserIcon',
        slug: 'management-users'
      },
      {
        url: '/management/packages',
        name: 'Packages',
        icon: 'PackageIcon',
        slug: 'management-packages'
      },
      {
        url: '/management/operating-systems',
        name: 'Operating Systems',
        icon: 'HardDriveIcon',
        slug: 'management-operating-systems'
      },
      {
        url: '/management/languages',
        name: 'Languages',
        icon: 'CodeIcon',
        slug: 'management-languages'
      },
      {
        url: '/management/protections',
        name: 'Protections',
        icon: 'ShieldIcon',
        slug: 'management-protections'
      },
      {
        url: '/management/attacks',
        name: 'Attacks',
        icon: 'TargetIcon',
        slug: 'management-attacks'
      },
      {
        url: '/management/rules',
        name: 'Rule Database',
        icon: 'ArchiveIcon',
        slug: 'management-rules'
      },
      
    ]
  }
]